import { AfterViewInit, Component, Injector, Input, ViewChild, forwardRef } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { InputConfig, InputType } from '../../../model';

/**
 * * Componentes de Inputs do Apolo, incluindo de Texto, Número e Área de Texto.
 */
@Component({
  selector: 'ui-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent implements ControlValueAccessor, AfterViewInit {

  /**
   * * Título do Input.
   */
  @Input() title: string = '';
  /**
   * * Configuração para montar o input.
   */
  @Input() input: InputConfig = {type: InputType.text};
  /**
   * * Input inválido.
   */
  @Input() invalid: boolean = false;

  private controlContainer!: ControlContainer;

  value: any = '';

  @ViewChild(FormControlDirective, {static: true})
  formControlDirective!: FormControlDirective;

  constructor(private inj: Injector) {}

  ngAfterViewInit() { 
    this.controlContainer = this.inj.get(ControlContainer);

    if (this.input.value) 
      this.value = this.input.value;
  }

  touched($event: FocusEvent) {
    if ($event.target)
      this.propagateChange(($event.target as HTMLInputElement).value);

    this.propagateTouched($event);
  }

  propagateChange = (_: any) => { };

  propagateTouched = (_: any) => { };

  /** ControlValueAccessor Methods **/

  writeValue(obj: any): void { 
    if (obj !== this.value) {
      this.value = obj;
      this.propagateChange(obj);
    }
  }

  registerOnChange(fn: () => {}) { this.propagateChange = fn; }

  registerOnTouched(fn: () => {}) { this.propagateTouched = fn; }

  setDisabledState?(isDisabled: boolean): void { this.input.disabled = isDisabled; }

  /**********************************************/

  get invalidState(): boolean {
    return (this.controlContainer?.invalid && this.controlContainer?.dirty) || this.invalid || false;
  }

  get dirty(): boolean | null {
    return this.controlContainer?.dirty;
  }

  get disabled(): boolean {
    return this.controlContainer?.disabled || this.input.disabled || false;
  }

  get required(): boolean {
    return this.controlContainer?.control?.hasValidator(Validators.required) || this.input.required || false;
  }

  get name(): string {
    return this.controlContainer?.name as string || this.input.name || '';
  }

  

}
